import React from 'react';
import PropTypes from 'prop-types';
import OpenEndedText from './OpenEndedText';
import OpenEndedNumeric from './OpenEndedNumeric';
import OpenEndedConstantSum from './OpenEndedConstantSum';
import useSetup from './hooks/useSetup';
import {
  QUESTION_MATRIX_OPEN_ENDED,
  QUESTION_MATRIX_OPEN_ENDED_NUMERIC,
  QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM,
} from '../../../../constants';

export default function MatrixOpenEnded({ question, getText }) {
  const {
    rows,
    openEndedType,
    openEndedStyle,
    openEndedInputSize,
    openEndedSignPlacement,
    openEndedSign,
    openEndedConstantSumType,
    min,
    max,
    decimals,
    total,
    showRequiredInputSymbol,
    minLength,
    maxLength,
  } = useSetup({
    question,
  });

  switch (openEndedType) {
    case QUESTION_MATRIX_OPEN_ENDED:
      return (
        <OpenEndedText
          rows={rows}
          openEndedStyle={openEndedStyle}
          openEndedInputSize={openEndedInputSize}
          openEndedSignPlacement={openEndedSignPlacement}
          getText={getText}
          showRequiredInputSymbol={showRequiredInputSymbol}
          minLength={minLength}
          maxLength={maxLength}
        />
      );
    case QUESTION_MATRIX_OPEN_ENDED_NUMERIC:
      return (
        <OpenEndedNumeric
          rows={rows}
          openEndedStyle={openEndedStyle}
          openEndedInputSize={openEndedInputSize}
          openEndedSignPlacement={openEndedSignPlacement}
          openEndedSign={openEndedSign}
          min={min}
          max={max}
          decimals={decimals}
          getText={getText}
          showRequiredInputSymbol={showRequiredInputSymbol}
        />
      );
    case QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM:
      return (
        <OpenEndedConstantSum
          rows={rows}
          openEndedStyle={openEndedStyle}
          openEndedInputSize={openEndedInputSize}
          openEndedSignPlacement={openEndedSignPlacement}
          openEndedSign={openEndedSign}
          openEndedConstantSumType={openEndedConstantSumType}
          min={min}
          max={max}
          decimals={decimals}
          total={total}
          getText={getText}
        />
      );
    default:
      throw new Error(
        `Matrix open ended with type ${openEndedType} is not implemented yet!`,
      );
  }
}

MatrixOpenEnded.propTypes = {
  question: PropTypes.object,
  getText: PropTypes.func,
};
